import React, { useState, useEffect } from "react";
import {
  updateFavoriteList,
  loadApColleges,
  loadTsColleges,
  fetchUserFavorites,
  loadApPharmacyColleges,
  loadTsPharmacyColleges,
} from "../api/getApi";
import "../components/custom.css"
// Remove these unused imports
// import SponcerCard from "../components/sponcerCard";
// import SponcerBillboard from "../components/sponcerBillboard";
import UserDetailsAlert from "../components/userDetailsAlert";
import SafetyMarginSlider from "../components/safetyMarginSlider";
import SearchInput from "../components/searchInput";
import TypeCheckboxes from "../components/typeCheckboxes";
import CollegeList from "../components/collegeList";
import SelectedList from "../components/selectedList";
import WarningAlert from "../components/warningAlert";
import {
  getRankKey,
  handleSearch,
  handleTypeFilterChange,
  addCollege,
  removeCollege,
  moveCollegeUp,
  moveCollegeDown,
  sortSelectedCollegesByRank,
  applyFilters,
} from "../actions/actions";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
import Text from "../components/text";

const Updatelist = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  // Get favoriteId from location state
  const { favoriteId } = location.state || {};
  // console.log(favoriteId)
  // console.log("Favorite ID from location state:", favoriteId);

  const [formData, setFormData] = useState({});
  const [listName, setListName] = useState("");
  const [colleges, setColleges] = useState([]);
  const [filteredColleges, setFilteredColleges] = useState([]);
  const [selectedColleges, setSelectedColleges] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [safetyMargin, setSafetyMargin] = useState(10);
  const [selectedPlaces, setSelectedPlaces] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [showPlaceDropdown, setShowPlaceDropdown] = useState(false);
  const [showBranchDropdown, setShowBranchDropdown] = useState(false);
  const [placeSearchTerm, setPlaceSearchTerm] = useState("");
  const [branchSearchTerm, setBranchSearchTerm] = useState("");
  const [isRankSorted, setIsRankSorted] = useState(false);
  const [originalOrder, setOriginalOrder] = useState([]);
  const [isAvailableCollegesFullScreen, setIsAvailableCollegesFullScreen] =
    useState(false);
  const [isSelectedCollegesFullScreen, setIsSelectedCollegesFullScreen] =
    useState(false);
  // Add state for fetching favorites
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Fetch favorite data when component mounts
  useEffect(() => {
    const fetchFavoriteData = async () => {
      if (!isAuthenticated) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const favorites = await fetchUserFavorites();

        if (favoriteId == null) {
          setError("No favorite ID provided");
          setLoading(false);
          return;
        }

        const favorite = favorites[favoriteId];

        if (favorite == null) {
          setError(`Favorite with ID ${favoriteId} not found`);
          setLoading(false);
          return;
        }

        setFormData(favorite.formData || {});
        setListName(favorite.name || "");
        setSelectedColleges(favorite.colleges || []);
        setIsSaved(true);

        // Create a copy of formData to modify if needed
        const requestData = { ...favorite.formData };

        // Load colleges based on exam type
        let response;
        switch (requestData.examType) {
          case "ap":
            response = await loadApColleges(requestData);
            break;
          case "ap_bipc":
            response = await loadApPharmacyColleges(requestData);
            break;
          case "ts":
            response = await loadTsColleges(requestData);
            break;
          case "ts_bipc":
            // Set year to "first" for TS BIPC
            requestData.year = "first";
            response = await loadTsPharmacyColleges(requestData);
            break;
          default:
            throw new Error("Invalid exam type");
        }

        if (response.success) {
          const collegeData = response.data || [];
          setColleges(collegeData);

          // Apply initial filters
          applyFilters(
            "", // empty search term
            [], // empty places array
            [], // empty branches array
            [], // empty types array
            collegeData,
            setFilteredColleges,
            favorite.formData,
            safetyMargin,
            getRankKey
          );
        }
      } catch (err) {
        console.error("Error fetching favorite data:", err);
        setError("Failed to load your college list. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchFavoriteData();
  }, [favoriteId, isAuthenticated, safetyMargin]);

  const updateSelection = async () => {
    if (!listName) {
      console.error("Error: listName is undefined");
      return;
    }

    // Check authentication instead of localStorage
    if (!isAuthenticated) {
      sessionStorage.setItem(
        "pendingFavorite",
        JSON.stringify({ name: listName, colleges: selectedColleges, formData })
      );
      navigate("/login");
      return;
    }

    try {
      // Updated API call - don't pass email
      const data = await updateFavoriteList(favoriteId, {
        name: listName,
        colleges: selectedColleges,
        formData,
      });
      if (data.success) {
        alert("Your college selection has been updated!");
        setIsSaved(true);
        setHasChanges(false);
      } else {
        alert("Failed to update your selection.");
      }
    } catch (error) {
      console.error("Error updating selection:", error);
      alert("An error occurred while updating your selection.");
    }
  };

  // Removed duplicate declaration of the proceed function

  useEffect(() => {
    const handleClickOutside = () => {
      setShowPlaceDropdown(false);
      setShowBranchDropdown(false);
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Proceed to print PDF
  const proceed = () => {
    if (isSaved && !hasChanges) {
      navigate("/review-report", {
        state: {
          selectedColleges,
          formData,
          favoriteIndex: favoriteId, // Change to favoriteIndex (favoriteId was actually the index)
          navigationfrom: true,
        },
      });
    } else {
      updateSelection()
        .then(() => {
          navigate("/review-report", {
            state: {
              selectedColleges,
              formData,
              favoriteIndex: favoriteId, // Change to favoriteIndex
              navigationfrom: true,
            },
          });
        })
        .catch((err) => {
          console.error("Failed to update selection:", err);
          alert("Failed to save your changes. Please try again.");
        });
    }
  };

  // Filter change handlers
  const handleTypeFilterChangeHandler = (type) =>
    handleTypeFilterChange(
      type,
      selectedTypes,
      setSelectedTypes,
      (search, places, branches, types) =>
        applyFilters(
          search,
          places,
          branches,
          types,
          colleges,
          setFilteredColleges,
          formData,
          safetyMargin,
          getRankKey
        ),
      searchTerm,
      selectedPlaces,
      selectedBranches
    );

  // Unique places and branches
  const uniquePlaces = [
    ...new Set(colleges.map((college) => college.place)),
  ].sort((a, b) => a.localeCompare(b));
  const uniqueBranches = [
    ...new Set(colleges.map((college) => college.branch_code)),
  ].sort((a, b) => a.localeCompare(b));
  const filteredPlaces = uniquePlaces.filter(
    (place) =>
      place && place.toLowerCase().includes(placeSearchTerm.toLowerCase())
  );
  const filteredBranches = uniqueBranches.filter(
    (branch) =>
      branch && branch.toLowerCase().includes(branchSearchTerm.toLowerCase())
  );

  // Handle place filter changes
  const handlePlaceFilterChange = (place) => {
    // console.log(
    //   `Toggle place: ${place}, Currently selected: ${selectedPlaces.includes(
    //     place
    //   )}`
    // );

    // Toggle the selected place
    const updatedSelectedPlaces = selectedPlaces.includes(place)
      ? selectedPlaces.filter((p) => p !== place) // Remove if already selected
      : [...selectedPlaces, place]; // Add if not selected

    // console.log("Updated places:", updatedSelectedPlaces);

    setSelectedPlaces(updatedSelectedPlaces);

    // Apply filters with the updated selected places
    applyFilters(
      searchTerm,
      updatedSelectedPlaces,
      selectedBranches,
      selectedTypes,
      colleges,
      setFilteredColleges,
      formData,
      safetyMargin,
      getRankKey
    );
  };

  // Handle branch filter changes
  const handleBranchFilterChange = (branch) => {
    // console.log(
    //   `Toggle branch: ${branch}, Currently selected: ${selectedBranches.includes(
    //     branch
    //   )}`
    // );

    // Toggle the selected branch
    const updatedSelectedBranches = selectedBranches.includes(branch)
      ? selectedBranches.filter((b) => b !== branch) // Remove if already selected
      : [...selectedBranches, branch]; // Add if not selected

    // console.log("Updated branches:", updatedSelectedBranches);

    setSelectedBranches(updatedSelectedBranches);

    // Apply filters with the updated selected branches
    applyFilters(
      searchTerm,
      selectedPlaces,
      updatedSelectedBranches,
      selectedTypes,
      colleges,
      setFilteredColleges,
      formData,
      safetyMargin,
      getRankKey
    );
  };

  return (
    <section className="container mx-auto">
      <Helmet>
        <title>{Text.Filter.Title} | CollegeRank</title>
        <meta name="description" content={Text.Filter.Description} />
      </Helmet>

      {/* Add error message display */}
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{error}</span>
        </div>
      )}

      <div className="flex flex-col">
        {/* Main Content Section */}
        {/* <div className="flex flex-col md:flex-row items-center justify-between mb-4">
          <UserDetailsAlert formData={formData} name={listName} />
        </div> */}
        <div className="grid md:grid-cols-6 gap-4 ">
          <div className="md:col-span-2 flex flex-col gap-4">
            <UserDetailsAlert formData={formData} name={listName} />
          </div>
          {/* Left column with stacked components */}
          <div className="md:col-span-2 flex flex-col gap-4">
            <SafetyMarginSlider
              safetyMargin={safetyMargin}
              setSafetyMargin={setSafetyMargin}
            />
          </div>
          <div className="md:col-span-2 flex flex-col gap-4">
            <TypeCheckboxes
              selectedTypes={selectedTypes}
              handleTypeFilterChange={handleTypeFilterChangeHandler}
            />
          </div>

          {/* Right Side Sponsor Card */}
          {/* <div className="md:col-span-3">
            <SponcerBillboard />
          </div> */}
        </div>

        {/* Lists Section */}
        {loading ? (
          <div className="flex flex-col items-center justify-center py-4">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            <p className="mt-4 text-gray-700">Loading college data...</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-3 gap-8 py-8">
            {/* Available Colleges */}            <div
              className={`md:col-span-2 bg-white rounded-lg shadow-sm p-4 ${
                isAvailableCollegesFullScreen ? "full-screen z-50" : ""
              }`}
            >
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold text-gray-800">
                  {Text.Filter.AvailableColleges}
                </h2>
                <button
                  onClick={() => setIsAvailableCollegesFullScreen((v) => !v)}
                  className="text-blue-500 hover:text-blue-700 focus:outline-none"
                  title={
                    isAvailableCollegesFullScreen
                      ? "Exit Full Screen"
                      : "Full Screen"
                  }
                >
                  {isAvailableCollegesFullScreen ? (
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                      />
                    </svg>
                  )}
                </button>
              </div>
              <div className="mt-4 mb-4">
                <SearchInput
                  onChange={(e) =>
                    handleSearch(
                      e,
                      setSearchTerm,
                      (search, places, branches, types) =>
                        applyFilters(
                          search,
                          places,
                          branches,
                          types,
                          colleges,
                          setFilteredColleges,
                          formData,
                          safetyMargin,
                          getRankKey
                        ),
                      selectedPlaces,
                      selectedBranches,
                      selectedTypes
                    )
                  }
                  placeholder="Search by college code, name, location or branch"
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <CollegeList
                filteredColleges={filteredColleges}
                selectedColleges={selectedColleges}
                addCollege={(college) =>
                  addCollege(
                    college,
                    selectedColleges,
                    setSelectedColleges,
                    setIsSaved,
                    isRankSorted,
                    setOriginalOrder
                  )
                }
                formData={formData}
                showPlaceDropdown={showPlaceDropdown}
                setShowPlaceDropdown={setShowPlaceDropdown}
                showBranchDropdown={showBranchDropdown}
                setShowBranchDropdown={setShowBranchDropdown}
                placeSearchTerm={placeSearchTerm}
                setPlaceSearchTerm={setPlaceSearchTerm}
                branchSearchTerm={branchSearchTerm}
                setBranchSearchTerm={setBranchSearchTerm}
                selectedPlaces={selectedPlaces}
                handlePlaceFilterChange={handlePlaceFilterChange}
                selectedBranches={selectedBranches}
                handleBranchFilterChange={handleBranchFilterChange}
                uniquePlaces={uniquePlaces}
                uniqueBranches={uniqueBranches}
                filteredPlaces={filteredPlaces}
                filteredBranches={filteredBranches}
                isFullScreen={isAvailableCollegesFullScreen}
              />
            </div>
            {/* Selected Colleges */}
            <div
              className={`md:col-span-1 bg-white rounded-lg shadow-sm p-3 ${
                isSelectedCollegesFullScreen ? "full-screen z-50" : ""
              }`}
            >
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold text-gray-800">
                  {Text.Filter.SelectedColleges}
                </h2>
                <button
                  onClick={() => setIsSelectedCollegesFullScreen((v) => !v)}
                  className="text-blue-500 hover:text-blue-700 focus:outline-none"
                  title={
                    isSelectedCollegesFullScreen
                      ? "Exit Full Screen"
                      : "Full Screen"
                  }
                >
                  {isSelectedCollegesFullScreen ? (
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                      />
                    </svg>
                  )}
                </button>
              </div>
              <SelectedList
                selectedColleges={selectedColleges}
                removeCollege={(college) =>
                  removeCollege(
                    college,
                    selectedColleges,
                    setSelectedColleges,
                    setIsSaved,
                    isRankSorted,
                    setOriginalOrder
                  )
                }
                moveCollegeUp={(index) =>
                  moveCollegeUp(
                    index,
                    selectedColleges,
                    setSelectedColleges,
                    setIsSaved,
                    isRankSorted,
                    setOriginalOrder
                  )
                }
                moveCollegeDown={(index) =>
                  moveCollegeDown(
                    index,
                    selectedColleges,
                    setSelectedColleges,
                    setIsSaved,
                    isRankSorted,
                    setOriginalOrder
                  )
                }
                sortSelectedCollegesByRank={() =>
                  sortSelectedCollegesByRank(
                    isRankSorted,
                    selectedColleges,
                    setSelectedColleges,
                    setIsRankSorted,
                    originalOrder,
                    setOriginalOrder,
                    getRankKey,
                    setIsSaved,
                    formData
                  )
                }
                formData={formData}
                isRankSorted={isRankSorted}
                setIsRankSorted={setIsRankSorted}
                originalOrder={originalOrder}
                setOriginalOrder={setOriginalOrder}
                setIsSaved={setIsSaved}
                isFullScreen={isSelectedCollegesFullScreen}
              />
            </div>
          </div>
        )}

        {/* Warning and Buttons */}
        <div className="grid md:grid-cols-8 gap-8">
          <div className="col-span-full">
            <WarningAlert />
          </div>

          {/* Desktop-only buttons */}
          <div className="col-span-2 hidden md:block">
            <button
              type="button"
              onClick={() => window.history.back()}
              className="flex-1 w-full sm:flex-none px-4 py-2.5 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors shadow-sm"
            >
              Back
            </button>
          </div>
          <div className="col-span-2 hidden md:block">
            <button
              type="button"
              onClick={() => {
                localStorage.removeItem("selectedColleges");
                setSelectedColleges([]);
                setIsSaved(false);
                setHasChanges(false);
                navigate("/filter", {
                  state: {
                    formData: formData,
                    listName: listName,
                    selectedColleges: [],
                  },
                });
              }}
              className="flex-1 w-full sm:flex-none px-4 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors shadow-sm"
            >
              Create New
            </button>
          </div>

          {/* Mobile and Desktop buttons container */}
          <div className="col-span-full md:col-span-4 grid grid-cols-2 gap-4">
            <button
              type="button"
              onClick={updateSelection}
              className="w-full px-4 py-2.5 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition-colors shadow-sm"
            >
              Update
            </button>
            <button
              type="button"
              onClick={proceed}
              disabled={selectedColleges.length === 0}
              className={`w-full px-4 py-2.5 rounded-lg shadow-sm ${
                selectedColleges.length === 0
                  ? "bg-blue-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              } text-white transition-colors`}
            >
              Save and Download
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Updatelist;
